import { graphql } from '../graphql';
import { useRequest } from '../hooks/useRequest';
const FORCE_CLOSE_CASE = graphql(`
  mutation ForceCloseCase {
    forceCloseCase
  }
`);
export const useForceCloseCaseRequest = () => {
    return useRequest(FORCE_CLOSE_CASE, {});
};
